/*
export declare var Shumway: {
    version: string;
    build: string;
}*/
export var Shumway = {
    version: '',
    build: ''
};
